var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid';
import { Translate } from "../../../I18N";








const calculateMorePages = (currentPage, totalPages) => {
  let page = currentPage + 1;
  const pages = [];

  while (pages.length < 5) {
    if (page + 1 === totalPages) {
      break;
    }

    pages.push((page + 1).toString());
    page += 1;
  }

  return pages;
};

const Paginator = ({ currentPage, totalPages, buildUrl, preventScrollReset }) => {
  const isFirstPage = currentPage === 1;
  const isLastPage = totalPages < 1 || currentPage === totalPages;
  const shouldDisplayShowMore = currentPage + 1 !== totalPages && !isLastPage;
  const [showMore, setShowMore] = useState(totalPages - currentPage < 6);

  return /*#__PURE__*/(
    _jsx("nav", { "aria-label": "Pagination" }, void 0, /*#__PURE__*/
    _jsx("ul", { className: "flex flex-wrap items-center" }, void 0, /*#__PURE__*/
    _jsx("li", {}, "previous",
    isFirstPage ? /*#__PURE__*/
    _jsx("button", {
      type: "button",
      disabled: true,
      className: "block px-3 py-1.5 ml-0 leading-snug text-gray-500 bg-white border border-gray-300 rounded-l-[4px]" }, void 0, /*#__PURE__*/

    _jsx(ChevronLeftIcon, { className: "w-[17px]" }), /*#__PURE__*/
    _jsx(Translate, { className: "sr-only" }, void 0, "Previous")
    ) : /*#__PURE__*/

    _jsx(Link, {
      to: buildUrl((currentPage - 1).toString()),
      preventScrollReset: preventScrollReset,
      className: "block px-3 py-1.5 ml-0 leading-snug text-gray-500 bg-white border border-gray-300 rounded-l-[4px] hover:bg-gray-100 hover:text-gray-700" }, void 0, /*#__PURE__*/

    _jsx(Translate, { className: "sr-only" }, void 0, "Previous"), /*#__PURE__*/
    _jsx(ChevronLeftIcon, { className: "w-[17px]" })
    )

    ),

    !isFirstPage && /*#__PURE__*/
    _jsx("li", {}, "first", /*#__PURE__*/
    _jsx(Link, {
      to: buildUrl('1'),
      preventScrollReset: preventScrollReset,
      "aria-current": "page",
      className: "px-3 py-1.5 leading-snug text-gray-500 bg-white border-r border-gray-300 border-y hover:bg-gray-100 hover:text-gray-700" }, void 0,
    "1"

    )
    ),


    !isFirstPage && currentPage - 1 !== 1 && /*#__PURE__*/
    _jsx("li", {}, currentPage - 1, /*#__PURE__*/
    _jsx(Link, {
      to: buildUrl((currentPage - 1).toString()),
      preventScrollReset: preventScrollReset,
      "aria-current": "page",
      className: "px-3 py-1.5 leading-snug text-gray-500 bg-white border-r border-gray-300 border-y hover:bg-gray-100 hover:text-gray-700" }, void 0,

    currentPage - 1
    )
    ), /*#__PURE__*/


    _jsx("li", {}, "current", /*#__PURE__*/
    _jsx(Link, {
      to: buildUrl(currentPage.toString()),
      preventScrollReset: preventScrollReset,
      "aria-current": "page",
      className: "px-3 py-1.5 leading-snug text-blue-600 border-r border-blue-300 border-y bg-blue-50" }, void 0,

    currentPage
    )
    ),

    !isLastPage && currentPage + 1 !== totalPages && /*#__PURE__*/
    _jsx("li", {}, currentPage + 1, /*#__PURE__*/
    _jsx(Link, {
      to: buildUrl((currentPage + 1).toString()),
      preventScrollReset: preventScrollReset,
      "aria-current": "page",
      className: "px-3 py-1.5 leading-snug text-gray-500 bg-white border-r border-gray-300 border-y hover:bg-gray-100 hover:text-gray-700" }, void 0,

    currentPage + 1
    )
    ),


    shouldDisplayShowMore && (
    showMore ?
    calculateMorePages(currentPage, totalPages).map((pageNumber) => /*#__PURE__*/
    _jsx("li", {}, `more-${pageNumber}`, /*#__PURE__*/
    _jsx(Link, {
      to: buildUrl(pageNumber),
      preventScrollReset: preventScrollReset,
      className: "px-3 py-1.5 leading-snug text-gray-500 bg-white border-r border-gray-300 border-y hover:bg-gray-100 hover:text-gray-700" }, void 0,

    pageNumber
    )
    )
    ) : /*#__PURE__*/

    _jsx("li", {}, "more", /*#__PURE__*/
    _jsx("button", {
      onClick: () => setShowMore(true),
      type: "button",
      className: "h-[35px] px-3 py-1.5 m-0 leading-snug text-gray-500 bg-white border-y border-r border-gray-300 hover:bg-gray-100 hover:text-gray-700" }, void 0, /*#__PURE__*/

    _jsx(Translate, { className: "sr-only" }, void 0, "Show more"), "..."

    )
    )),


    !isLastPage && /*#__PURE__*/
    _jsx("li", {}, "last", /*#__PURE__*/
    _jsx(Link, {
      to: buildUrl(totalPages.toString()),
      preventScrollReset: preventScrollReset,
      className: "px-3 py-1.5 leading-snug text-gray-500 bg-white border-gray-300 border-y hover:bg-gray-100 hover:text-gray-700" }, void 0,

    totalPages
    )
    ), /*#__PURE__*/


    _jsx("li", {}, "next",
    isLastPage ? /*#__PURE__*/
    _jsx("button", {
      type: "button",
      disabled: true,
      className: "block px-3 py-1.5 leading-snug text-gray-500 bg-white border border-gray-300 rounded-r-[4px]" }, void 0, /*#__PURE__*/

    _jsx(ChevronRightIcon, { className: "w-[17px]" }), /*#__PURE__*/
    _jsx(Translate, { className: "sr-only" }, void 0, "Next")
    ) : /*#__PURE__*/

    _jsx(Link, {
      to: buildUrl((currentPage + 1).toString()),
      preventScrollReset: preventScrollReset,
      className: "block px-3 py-1.5 leading-snug text-gray-500 bg-white border border-gray-300 rounded-r-[4px] hover:bg-gray-100 hover:text-gray-700" }, void 0, /*#__PURE__*/

    _jsx(Translate, { className: "sr-only" }, void 0, "Next"), /*#__PURE__*/
    _jsx(ChevronRightIcon, { className: "w-[17px]" })
    )

    )
    )
    ));

};

export { Paginator };